<template>
  <a-cascader
    placeholder="Please select"
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
    v-model="modelList[name]"
    :show-search="{ filter }"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { Cascader } from "ant-design-vue";
export default {
  mixins: [formMixin],
  components: {
    [Cascader.name]: Cascader,
  },
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
  methods: {
    filter (inputValue, path) {
      this.findEvent(this.funcList, this.name, "flter", inputValue, path);
    },
  },
};
</script>
